(ns frontend.ui.component.grid.view
  "https://herb.roosta.sh/#media-queries
  https://getbootstrap.com/docs/5.0/examples/grid/#containers
  https://css-tricks.com/snippets/css/a-guide-to-flexbox/
  https://www.w3schools.com/css/css_rwd_mediaqueries.asp"
  (:require
   [frontend.ui.component.grid.style :as style]
   [herb.core :refer [<class]]))

(defn column
  ;; TODO if no props at all, set a default of `:span 12`?
  [props & children]
  (into [:div {:class (<class style/column props)}]
        children))

(defn row
  [props & children]
  (into [:div {:class (<class style/row props)}]
        children))

(defn container-style
  [props]
  {:class (<class style/container props)})

(defn container
  [props & children]
  (into [:div (container-style props)]
        children))
